/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */

/**
 * Anenumeration.
 */
export type ErrorCode = typeof ErrorCode[keyof typeof ErrorCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorCode = {
  NUMBER_0001: '0001',
  NUMBER_0002: '0002',
  NUMBER_0003: '0003',
  NUMBER_0004: '0004',
  NUMBER_1001: '1001',
  NUMBER_1002: '1002',
  NUMBER_1003: '1003',
  NUMBER_1004: '1004',
  NUMBER_1005: '1005',
  NUMBER_1006: '1006',
  NUMBER_1007: '1007',
  NUMBER_1101: '1101',
  NUMBER_1102: '1102',
  NUMBER_1103: '1103',
  NUMBER_1201: '1201',
  NUMBER_1202: '1202',
  NUMBER_1301: '1301',
  NUMBER_2001: '2001',
  NUMBER_2002: '2002',
  NUMBER_2003: '2003',
  NUMBER_3001: '3001',
  NUMBER_5001: '5001',
  NUMBER_5002: '5002',
  NUMBER_6001: '6001',
  NUMBER_6002: '6002',
  NUMBER_6003: '6003',
  NUMBER_6004: '6004',
  NUMBER_8000: '8000',
  NUMBER_8001: '8001',
  NUMBER_8002: '8002',
  NUMBER_8003: '8003',
  NUMBER_8004: '8004',
  NUMBER_9001: '9001',
  NUMBER_9002: '9002',
  NUMBER_9003: '9003',
  NUMBER_10001: '10001',
  NUMBER_10002: '10002',
  NUMBER_10003: '10003',
  NUMBER_10004: '10004',
} as const;
